import { APPLICATION_GROUP_BY, Route } from '@/core/entities';
import { Main } from '@/core/views';
import Home from '@/modules/customization/pages/home/home';
import ICONS from '@/shared/entities/constants/icons';
import { PERMISSIONS } from '@/utils/checkPermission';

export enum ROUTE_CUSTOMIZATION_NAME {
  CUSTOMIZATION_APP = 'contract-app',
}

const customizationsRoute: Route[] = [
  {
    path: '/companies/:companyId/customizations/app',
    Component: Main,
    id: ROUTE_CUSTOMIZATION_NAME.CUSTOMIZATION_APP,

    meta: {
      groupedBy: APPLICATION_GROUP_BY.COMPANY,
      showApplicationMenu: true,
      nameMenu: 'Aplicativo Vitta',
      icon: ICONS.CUSTOMIZATION,
      permission: {
        values: [PERMISSIONS.CUSTOMIZIATIONS_APP],
      },
    },
    loader() {
      return {
        title: 'Aplicativo Vitta',
      };
    },

    children: [
      {
        index: true,
        Component: Home,
      },
    ],
  },
];

export default customizationsRoute;
